/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  CreateDriver200Response,
  CreateDriverRequest,
  DriverPaginationResponse,
  DuplicateData,
  InternalServerError,
  NotFound,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
  UpdateDriverRequest,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    CreateDriver200ResponseFromJSON,
    CreateDriver200ResponseToJSON,
    CreateDriverRequestFromJSON,
    CreateDriverRequestToJSON,
    DriverPaginationResponseFromJSON,
    DriverPaginationResponseToJSON,
    DuplicateDataFromJSON,
    DuplicateDataToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    NotFoundFromJSON,
    NotFoundToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
    UpdateDriverRequestFromJSON,
    UpdateDriverRequestToJSON,
} from '../models/index';

export interface CreateDriverOperationRequest {
    createDriverRequest: CreateDriverRequest;
}

export interface CreateDriversCsvRequest {
    file: Blob;
}

export interface DeleteDriverRequest {
    ifMatch: number;
    driverCode: string;
}

export interface GetDriversRequest {
    page?: number;
    count?: number;
    sort?: GetDriversSortEnum;
    loginIdKeyword?: string;
    driverNameKeyword?: string;
    driverNameKanaKeyword?: string;
    gender?: number;
    groupNameKeyword?: string;
    companyNameKeyword?: string;
    salesOfficeNameKeyword?: string;
    sortKey?: string;
}

export interface GetDriversCsvRequest {
    loginIdKeyword?: string;
    driverNameKeyword?: string;
    driverNameKanaKeyword?: string;
    gender?: number;
    groupNameKeyword?: string;
    companyNameKeyword?: string;
    salesOfficeNameKeyword?: string;
    sortKey?: string;
    sort?: GetDriversCsvSortEnum;
}

export interface UpdateDriverOperationRequest {
    ifMatch: number;
    driverCode: string;
    updateDriverRequest: UpdateDriverRequest;
}

export interface UpdateDriversCsvRequest {
    file: Blob;
}

/**
 * 
 */
export class DriversApi extends runtime.BaseAPI {

    /**
     * 本APIは、ドライバー情報をアプリケーションDBに登録します。<br> 
     * ドライバーの登録
     */
    async createDriverRaw(requestParameters: CreateDriverOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDriver200Response>> {
        if (requestParameters['createDriverRequest'] == null) {
            throw new runtime.RequiredError(
                'createDriverRequest',
                'Required parameter "createDriverRequest" was null or undefined when calling createDriver().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/drivers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDriverRequestToJSON(requestParameters['createDriverRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDriver200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、ドライバー情報をアプリケーションDBに登録します。<br> 
     * ドライバーの登録
     */
    async createDriver(requestParameters: CreateDriverOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDriver200Response> {
        const response = await this.createDriverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、CSV形式で指定された複数のドライバー情報を一括登録します。 
     * ドライバー一括登録（CSV）
     */
    async createDriversCsvRaw(requestParameters: CreateDriversCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling createDriversCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/drivers/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 本APIは、CSV形式で指定された複数のドライバー情報を一括登録します。 
     * ドライバー一括登録（CSV）
     */
    async createDriversCsv(requestParameters: CreateDriversCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createDriversCsvRaw(requestParameters, initOverrides);
    }

    /**
     * 本APIは、指定されたドライバーコードに紐づくドライバーを削除します。 
     * ドライバーの削除
     */
    async deleteDriverRaw(requestParameters: DeleteDriverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDriver200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling deleteDriver().'
            );
        }

        if (requestParameters['driverCode'] == null) {
            throw new runtime.RequiredError(
                'driverCode',
                'Required parameter "driverCode" was null or undefined when calling deleteDriver().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/drivers/{driver_code}`;
        urlPath = urlPath.replace(`{${"driver_code"}}`, encodeURIComponent(String(requestParameters['driverCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDriver200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、指定されたドライバーコードに紐づくドライバーを削除します。 
     * ドライバーの削除
     */
    async deleteDriver(requestParameters: DeleteDriverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDriver200Response> {
        const response = await this.deleteDriverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ドライバー一覧情報取得
     */
    async getDriversRaw(requestParameters: GetDriversRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DriverPaginationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['loginIdKeyword'] != null) {
            queryParameters['login_id_keyword'] = requestParameters['loginIdKeyword'];
        }

        if (requestParameters['driverNameKeyword'] != null) {
            queryParameters['driver_name_keyword'] = requestParameters['driverNameKeyword'];
        }

        if (requestParameters['driverNameKanaKeyword'] != null) {
            queryParameters['driver_name_kana_keyword'] = requestParameters['driverNameKanaKeyword'];
        }

        if (requestParameters['gender'] != null) {
            queryParameters['gender'] = requestParameters['gender'];
        }

        if (requestParameters['groupNameKeyword'] != null) {
            queryParameters['group_name_keyword'] = requestParameters['groupNameKeyword'];
        }

        if (requestParameters['companyNameKeyword'] != null) {
            queryParameters['company_name_keyword'] = requestParameters['companyNameKeyword'];
        }

        if (requestParameters['salesOfficeNameKeyword'] != null) {
            queryParameters['sales_office_name_keyword'] = requestParameters['salesOfficeNameKeyword'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drivers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DriverPaginationResponseFromJSON(jsonValue));
    }

    /**
     * ドライバー一覧情報取得
     */
    async getDrivers(requestParameters: GetDriversRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DriverPaginationResponse> {
        const response = await this.getDriversRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ドライバー一覧取得（CSV）
     */
    async getDriversCsvRaw(requestParameters: GetDriversCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['loginIdKeyword'] != null) {
            queryParameters['login_id_keyword'] = requestParameters['loginIdKeyword'];
        }

        if (requestParameters['driverNameKeyword'] != null) {
            queryParameters['driver_name_keyword'] = requestParameters['driverNameKeyword'];
        }

        if (requestParameters['driverNameKanaKeyword'] != null) {
            queryParameters['driver_name_kana_keyword'] = requestParameters['driverNameKanaKeyword'];
        }

        if (requestParameters['gender'] != null) {
            queryParameters['gender'] = requestParameters['gender'];
        }

        if (requestParameters['groupNameKeyword'] != null) {
            queryParameters['group_name_keyword'] = requestParameters['groupNameKeyword'];
        }

        if (requestParameters['companyNameKeyword'] != null) {
            queryParameters['company_name_keyword'] = requestParameters['companyNameKeyword'];
        }

        if (requestParameters['salesOfficeNameKeyword'] != null) {
            queryParameters['sales_office_name_keyword'] = requestParameters['salesOfficeNameKeyword'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drivers/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * ドライバー一覧取得（CSV）
     */
    async getDriversCsv(requestParameters: GetDriversCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDriversCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、指定されたドライバーコードに紐づくドライバー情報を更新します。 
     * ドライバーの更新
     */
    async updateDriverRaw(requestParameters: UpdateDriverOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDriver200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateDriver().'
            );
        }

        if (requestParameters['driverCode'] == null) {
            throw new runtime.RequiredError(
                'driverCode',
                'Required parameter "driverCode" was null or undefined when calling updateDriver().'
            );
        }

        if (requestParameters['updateDriverRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDriverRequest',
                'Required parameter "updateDriverRequest" was null or undefined when calling updateDriver().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/drivers/{driver_code}`;
        urlPath = urlPath.replace(`{${"driver_code"}}`, encodeURIComponent(String(requestParameters['driverCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDriverRequestToJSON(requestParameters['updateDriverRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDriver200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、指定されたドライバーコードに紐づくドライバー情報を更新します。 
     * ドライバーの更新
     */
    async updateDriver(requestParameters: UpdateDriverOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDriver200Response> {
        const response = await this.updateDriverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CSVファイルからドライバーを一括更新します。 
     * ドライバー一括更新（CSV）
     */
    async updateDriversCsvRaw(requestParameters: UpdateDriversCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling updateDriversCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/drivers/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CSVファイルからドライバーを一括更新します。 
     * ドライバー一括更新（CSV）
     */
    async updateDriversCsv(requestParameters: UpdateDriversCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDriversCsvRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetDriversSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetDriversSortEnum = typeof GetDriversSortEnum[keyof typeof GetDriversSortEnum];
/**
 * @export
 */
export const GetDriversCsvSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetDriversCsvSortEnum = typeof GetDriversCsvSortEnum[keyof typeof GetDriversCsvSortEnum];
